module.exports = __webpack_public_path__ + "static/img/down-svgrepo-com.1124bd44.svg";